/**
 * Empty state component shown when user has no favorite trips.
 */
export const EmptyFavoritesState = () => {
  return (
    <div className="text-center py-20 bg-surface rounded-3xl shadow-sm">
      <div className="mx-auto h-24 w-24 text-disabled">
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
          />
        </svg>
      </div>
      <h3 className="mt-2 text-sm  text-main">No favorite trips yet</h3>
      <p className="mt-1 text-sm text-muted">Start following trips to see them here.</p>
    </div>
  );
};
